import fetch from 'utils/fetch';
import {
  getProfile,
  getRegion,
  getDepartment,
  getTags,
} from '../reducers/diffusion';
import { getFilteredUsers } from '../api/index';

export const REQUEST_TAGS = 'REQUEST_TAGS';
export const RECEIVE_TAGS = 'RECEIVE_TAGS';
export const PROFILE_CHANGED = 'PROFILE_CHANGED';
export const REGION_CHANGED = 'REGION_CHANGED';
export const DEPARTMENT_CHANGED = 'DEPARTMENT_CHANGED';
export const TAGS_CHANGED = 'TAGS_CHANGED';
export const USER_CHOICES_CHANGED = 'USER_CHOICES_CHANGED';
export const USER_SELECTED = 'USER_SELECTED';
export const ALL_USER_SELECTED = 'ALL_USER_SELECTED';
export const ALL_USER_UNSELECTED = 'ALL_USER_UNSELECTED';
export const RESET_STATE = 'RESET_STATE';

function requestTags() {
  return {
    type: REQUEST_TAGS,
  };
}

export function receiveTags(tags) {
  return {
    type: RECEIVE_TAGS,
    payload: {
      tags,
    },
  };
}

const computeFilterFromState = state => ({
  profile: getProfile(state),
  region: getRegion(state),
  department: getDepartment(state),
  tags: getTags(state),
});

const refreshUserList = (dispatch, state) => {
  getFilteredUsers(computeFilterFromState(state)).then(response => {
    dispatch({
      type: USER_CHOICES_CHANGED,
      payload: {
        users: response,
      },
    });
  });
};

export const initUserList = () => (dispatch, state) => {
  getFilteredUsers({
    profiles: null,
    regions: null,
    departments: null,
    tags: [],
  }).then(response => {
    dispatch({
      type: USER_CHOICES_CHANGED,
      payload: {
        users: response,
      },
    });
  });
};

export const onUserSelected = user => (dispatch, getState) => {
  dispatch({
    type: USER_SELECTED,
    payload: {
      user,
    },
  });
};

export const resetState = () => (dispatch, getState) => {
  dispatch({
    type: RESET_STATE,
  });
  refreshUserList(dispatch, getState());
  fetchTags()(dispatch);
};

export const onSelectAll = () => (dispatch, getState) => {
  dispatch({
    type: ALL_USER_SELECTED,
  });
};

export const onUnselectAll = () => (dispatch, getState) => {
  dispatch({
    type: ALL_USER_UNSELECTED,
  });
};

export const profileChanged = profile => (dispatch, getState) => {
  dispatch({
    type: PROFILE_CHANGED,
    payload: {
      profile,
    },
  });

  refreshUserList(dispatch, getState());
};

export const regionChanged = region => (dispatch, getState) => {
  dispatch({
    type: REGION_CHANGED,
    payload: {
      region,
    },
  });

  refreshUserList(dispatch, getState());
};

export const departmentChanged = department => (dispatch, getState) => {
  dispatch({
    type: DEPARTMENT_CHANGED,
    payload: {
      department,
    },
  });

  refreshUserList(dispatch, getState());
};

export const tagsChanged = tags => (dispatch, getState) => {
  dispatch({
    type: TAGS_CHANGED,
    payload: {
      tags,
    },
  });

  refreshUserList(dispatch, getState());
};

function fetchTags() {
  return dispatch => {
    dispatch(requestTags());
    fetch('/admin/users/tags.json')
      .then(r => r.json())
      .then(tags => dispatch(receiveTags(tags)));
  };
}

function shouldFetchTags(state) {
  const { loaded, isFetching, didInvalidate } = state.diffusion.selection;
  if (!loaded) {
    return true;
  } else if (isFetching) {
    return false;
  }

  return didInvalidate;
}

export function fetchTagsIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchTags(getState())) {
      return dispatch(fetchTags());
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/diffusion/actions/diffusion.js